//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      badge: {}
    };
  },
  methods: {
    $ready: function $ready() {
      this.badge = this.spec.badge || {};
    },
    badgeExists: function badgeExists() {
      var exists = false;
      Utils.type.ifString(this.badge.text, function (text) {
        exists = text.length > 0;
      });
      return exists;
    },
    styles: function styles() {
      if (this.spec.width == "matchParent") {
        return {
          width: "100%"
        };
      }

      return {};
    }
  }
};